import script from "./RealTimeInterfaceView.vue?vue&type=script&setup=true&lang=js"
export * from "./RealTimeInterfaceView.vue?vue&type=script&setup=true&lang=js"

import "./RealTimeInterfaceView.vue?vue&type=style&index=0&id=e0b27cca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0b27cca"]])

export default __exports__